

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumAutoCreationDocumentTypes, EnumDocumentFilteringOption } from './../enums';
import { EnumSystemTypes } from './../enums';
export class SystemOption extends BaseEntity
{   
    public SeriesReceipt: string; 
    public MaxNumberOfPayments: number; 
    public AutoCreationDocumentType: EnumAutoCreationDocumentTypes; 
    public SeriesInvoice: string; 
    public SeriesOrder: string; 
    public LoginLifeTimePDFDays: number; 
    public AdminCardCode: string; 
    public AdminEmail: string; 
    public SystemType: EnumSystemTypes; 
    public IsEnableMultiCompany: boolean; 
    public GoCreditUserName: string; 
    public GoCreditPassword: string; //WRITE ONLY (BlockRead)
    public GoCreditPaymentPage: string; 
    public GoCreditPaymentPageEN: string; 
    public GoCreditTerminalNumber: string; 
    public InvoiceOneUserName: string; 
    public InvoiceOnePassword: string; //WRITE ONLY (BlockRead)
    public InvoiceOneSenderEmailAddress: string; 
    public InvoiceOneSenderClientUserName: string; 
    public InvoiceOneCCEmailAddress: string; 
    public InvoiceOneIsSendAsAttachment: boolean; 
    public InvoiceOneReceiptTemplateID: number; 
    public InvoiceOneReceiptTemplateIDEng: number; 
    public InvoiceOneReceiptDocCode: string; 
    public InvoiceOneReceiptDocCodeEng: string; 
    public InvoiceOneInvoiceTemplateID: number; 
    public InvoiceOneInvoiceTemplateIDEng: number; 
    public InvoiceOneInvoiceDocCode: string; 
    public InvoiceOneInvoiceDocCodeEng: string; 
    public InvoiceOneOrderTemplateID: number; 
    public InvoiceOneOrderTemplateIDEng: number; 
    public InvoiceOneOrderDocCode: string; 
    public InvoiceOneOrderDocCodeEng: string; 
    public InvoiceOneIsAllowEmail: boolean; 
    public InvoiceOneIsAllowSMS: boolean; 
    public InvoiceOneIsAllowWhatsapp: boolean; 
    public IsAllowLedger: boolean; 
    public IsAllowInvoices: boolean; 
    public IsAllowAgingReport: boolean; 
    public IsAllowMyDetails: boolean; 
    public IsAllowDeliveries: boolean; 
    public IsShowBalanceLate: boolean; 
    public IsShowAdditionalNotes: boolean; 
    public IsShowOpenOnly: boolean; 
    public IsShowFromDate: boolean; 
    public ShowFromDate: Date; 
    public IsAllowPayment: boolean; 
    public IsAllowChangePaymentSum: boolean; 
    public IsAllowChangePaymentsCount: boolean; 
    public IsAllowPaymentByDocumentItems: boolean; 
    public IsAllowPaymentSendEmail: boolean; 
    public IsAllowPaymentByExistsCreditCard: boolean; 
    public IsAllowSavePermanentCreditCard: boolean; 
    public IsAllowPaypalPayment: boolean; 
    public IsAllowBitPayment: boolean; 
    public IsShowCCConsent: boolean; 
    public IsShowCCConsentText: string; 
    public IsAllowCreditCardEdit: boolean; 
    public IsAllowContactPersons: boolean; 
    public IsAllowContactPersonsEdit: boolean; 
    public IsAllowBillCustomerAddresses: boolean; 
    public IsAllowBillCustomerAddressesEdit: boolean; 
    public IsAllowShipCustomerAddresses: boolean; 
    public IsAllowShipCustomerAddressesEdit: boolean; 
    public IsShowBalance: boolean; 
    public IsShowMaxBalance: boolean; 
    public IsShowObligo: boolean; 
    public IsShowMaxObligo: boolean; 
    public IsShowBankDetails: boolean; 
    public IsAllowBankDetailsEdit: boolean; 
    public IsShowCreditCard: boolean; 
    public IsAllowLoginFromEmailLink: boolean; 
    public IsAllowLoginFromEmailInvoiceLink: boolean; 
    public IsAllowLoginFromEmailOrderLink: boolean; 
    public IsAllowLoginFromEmailPriceProposalLink: boolean; 
    public IsAllowLoginFromEmailDeliveryLink: boolean; 
    public IsAllowLoginFromEmailCustomerLink: boolean; 
    public IsShowAttachedDocuments: boolean; 
    public IsShowAttachedDocumentsToBaseEntity: boolean; 
    public IsShowAttachedDocumentsToBaseBaseEntity: boolean; 
    public DocumentFilteringOption: EnumDocumentFilteringOption;
    public DefaultMonthToShow: number;

    public IsAllowViewingUnsentInvoices: boolean;
    public IsAllowViewingUnsentReceipt: boolean;
    public IsAllowViewingUnsentDeliveries: boolean;
    public UnsentInvoicesTemplate: string;
    public UnsentReceiptsTemplate: string;
    public UnsentDeliveriesTemplate: string;
    public UnsentRefundTemplate: string;
    public UnsentReturnTemplate: string;
    
    
}



